import {Colors} from "@arboxappv4/shared/src/styles/Colors";

export const getAntTheme = () => {
    return {
        token: {
            colorPrimary: Colors.siteBlack,
            borderRadius: 5,
            colorError: Colors.redPinkColor,
            fontFamily: 'Ploni',
            fontSize: 16,
            colorText: Colors.siteBlack,
            colorSuccessBg: Colors.siteSuccessBg,
            colorSuccessBorder: Colors.siteSuccessBorder,
        },
        components: {
            Input: {
                colorBgContainer: Colors.white,
                colorBorder: Colors.siteScheduleBorder,
                controlOutlineWidth: 0,
                colorPrimaryHover: Colors.lightGrey,
                fontSize: 16,
                controlHeight: 38,
                activeBg: Colors.white,
                activeBorderColor: Colors.siteBlack,
                hoverBg: Colors.inputHoverBg,
                hoverBorderColor: Colors.siteScheduleBorder,
            },
            Button: {
                controlHeight: 38,
                controlHeightLG: 49,
                lineWidth: 1,
                colorBorder: Colors.siteBlack,
                colorPrimaryHover: Colors.siteBlackHover,
                fontSizeLG: 20,
                colorError: Colors.dangerButtonRed,
                colorErrorHover: Colors.dangerButtonRed
            },
            DatePicker: {
                controlOutlineWidth: 0,
                fontFamily: 'Ploni',
                controlHeight: 38,
                colorBgContainer: Colors.white,
                activeBg: Colors.white,
                hoverBg: Colors.inputHoverBg,
                activeBorderColor: Colors.siteBlack,
                hoverBorderColor: Colors.siteScheduleBorder,
                colorBorder: Colors.siteScheduleBorder,
            },
            Select: {
                controlItemBgActive: 'transparent',
                controlHeight: 38,
                colorBgContainer: Colors.white,
                colorBorder: Colors.siteScheduleBorder,
                colorPrimaryHover: Colors.greyText,
                controlOutline: 'rgba(33,33,33,0.1)'
            },
            Collapse: {
                colorTextDisabled: 'rgba(0,0,0,0.5)'
            },
            Avatar: {
                textFontSize: 16,
                colorTextLightSolid: Colors.siteBlack
            },
            Card: {
                boxShadowCard: '-2px 4px 8px 0px #F1F1F1',
            },
            Divider: {
                colorText: Colors.siteBlack,
                fontSize: 14
            }
        }
    }
}